import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import { IChatVariablesService } from 'vscode/vscode/vs/workbench/contrib/chat/common/chatVariables.service';

let ChatHistoryVariables = class ChatHistoryVariables extends Disposable {
    constructor(chatVariablesService) {
        super();
        this._register(chatVariablesService.registerVariable({ name: 'response', description: '', canTakeArgument: true, hidden: true }, async (message, arg, model, progress, token) => {
            if (!arg) {
                return undefined;
            }
            const responseNum = parseInt(arg, 10);
            const response = model.getRequests()[responseNum - 1].response;
            if (!response) {
                return undefined;
            }
            return [{ level: 'full', value: response.response.asString() }];
        }));
    }
};
ChatHistoryVariables = ( __decorate([
    ( __param(0, IChatVariablesService))
], ChatHistoryVariables));
( Registry.as(Extensions.Workbench)).registerWorkbenchContribution(ChatHistoryVariables, 4 );
